import { render, staticRenderFns } from "./badgeMaintain.vue?vue&type=template&id=5d0bcdc0&scoped=true&"
import script from "./badgeMaintain.vue?vue&type=script&lang=js&"
export * from "./badgeMaintain.vue?vue&type=script&lang=js&"
import style0 from "./badgeMaintain.vue?vue&type=style&index=0&id=5d0bcdc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0bcdc0",
  null
  
)

export default component.exports